import { Close } from 'components/Icons/components'
import withCondition from 'components/withCondition'
import styled from 'styled-components'
import { btnBorderRadius, grayDarkest, grayLightest, media } from 'utils/style-utils'

import { GAME_WIDTHS } from '../styles'

export const GamesGridBox = styled.div`
  display: grid;
  margin: 0 -1rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(${GAME_WIDTHS.lg}, 1fr));

  ${media.md`
    grid-template-columns: repeat(auto-fit, minmax(${GAME_WIDTHS.md}, 1fr));
  `}

  ${media.sm`
    grid-template-columns: repeat(auto-fit, minmax(${GAME_WIDTHS.sm}, 1fr));
  `}

  ${media.xs`
    grid-template-columns: repeat(auto-fit, minmax(${GAME_WIDTHS.xs}, 1fr));
  `}
`

export const SelectedFiltersBox = styled.div`
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
`

const StyledPill = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.75rem;

  background: ${grayDarkest};
  color: ${grayLightest};
  font-size: 0.75rem;
  border-radius: ${btnBorderRadius};
`

export const X = styled(Close)`
  width: 1rem;
  fill: ${grayLightest};
`

export const Pill = withCondition(StyledPill)
